<template>
     <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="52%"
            height="100%"
            class="modalDialog"
            no-click-animation
          >
            <div class="memberAdd">
                <v-card class="cardWrap">
                    <CardTitle :title="page_title" />
                    <v-card-actions class="cardWrap__scroll">
                      <v-container>
                        <v-form
                            class="cardWrap__fromArea"
                            ref="form"
                            :lazy-validation="lazy"
                        >
                            <v-row justify="space-around" class="formWidth">
                                <div class="cardWrap__fromArea__title">グループコード</div>
                                    <v-text-field
                                        class="px-3"
                                        v-model="from_set_data.golf_group_code"
                                        maxlength="4"
                                        :disabled="changeModeStatus"
                                        :rules="[rules.format_golf_group_code, rules.required_golf_group, rules.max_length_golf_group]"
                                    />
                            </v-row>
                            <v-row justify="space-around">
                                <div class="cardWrap__fromArea__title">グループネーム</div>
                                    <v-text-field
                                        class="px-3"
                                        v-model="from_set_data.golf_group_name"
                                        maxlength="50"
                                        :rules="[rules.required_golf_group_name, rules.max_length_golf_group_name]"
                                    />
                            </v-row>
                            <v-row justify="space-around">
                            <div class="cardWrap__fromArea__title">ポイントタイプ</div>
                                <v-select
                                    class="px-3"
                                    :items="typeSelect"
                                    item-text="code_name"
                                    item-value="code"
                                    v-model="from_set_data.point_use_type"
                                    :rules="[rules.required]"
                                />
                            </v-row>
                            <v-row justify="space-around">
                            <div class="cardWrap__fromArea__title px-4 body-2">期間限定ポイント利用区分</div>
                                <v-select
                                    class="px-3"
                                    :items="remainderType"
                                    item-text="code_name"
                                    item-value="code"
                                    v-model="from_set_data.point_remainder_type"
                                    :rules="[rules.required]"
                                />
                            </v-row>
                        </v-form>
                      </v-container>
                    </v-card-actions>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="green darken-4" text @click="closeModal">閉じる</v-btn>
                      <v-btn color="green darken-4" text v-if="addModeStatus" @click="validateCheck">登録</v-btn>
                      <v-btn color="green darken-4" text v-if="changeModeStatus" @click="validateCheck">変更</v-btn>
                    </v-card-actions>
                </v-card>
            </div>
            <AddOverlay
              page-name="ゴルフグループ"
              @processing="registerGolfGroup"
              @cancel="addOverlay = !addOverlay"
              :process-result="process"
              :overlay-switch="addOverlay"
            />
            <ChangeOverlay
              page-name="ゴルフグループ"
              @processing="updateGolfGroup"
              @cancel="changeOverlay = !changeOverlay"
              :process-result="process"
              :OverlaySwitch="changeOverlay"
            />
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import {
    REGISTER_GOLFGROUP,
    UPDATE_GOLFGROUP } from '@/constants/master';
import { InputPagesMixin } from './../mixin/InputPagesMixin';
import ChangeOverlay from '../overlay/ChangeOverlay';
import AddOverlay from '../overlay/AddOverlay';
import validater from '@/lib/validater.js';

export default {
    components: {
        CardTitle,
        AddOverlay,
        ChangeOverlay
    },
    // マスタ管理の共通データはMixinで取得する ./mixin/InputPagesMixin.js
    mixins: [InputPagesMixin],
    // 親コンポーネント(GolfGroup.vue)から渡される値 更新処理で使用
    props: ['editInfo', 'typeSelect', 'remainderType'],
    data () {
        return {
            page_title: 'ゴルフグループ登録',
            // 入力値
            from_set_data: {
                golf_group_code: '',
                golf_group_name: '',
                point_use_type: '',
                point_remainder_type: ''
            },
            rules: {
                // ゴルフグループバリデーション
                required_golf_group: value => !!value || this.$t('error.validation.required.golfGroup'),
                max_length_golf_group: value => value.length <= 4 || this.$t('error.validation.length.golfGroup'),
                format_golf_group_code: value => validater.checkNum(value) || this.$t('error.validation.format.num'),
                // ゴルフグループ名バリデーション
                required_golf_group_name: value => !!value || this.$t('error.validation.required.golfGroupName'),
                max_length_golf_group_name: value => value.length <= 50 || this.$t('error.validation.length.golfGroupName'),
                // セレクトボックスの必須項目
                required: value => !!value || this.$t('error.validation.required.any')
            }
        };
    },
    created () {
        this.Initialize();
    },
    computed: {
        addModeStatus () {
            return this.modeStatus === 'addMode';
        },
        changeModeStatus () {
            return this.modeStatus === 'changeMode';
        }
    },
    watch: {
        // modeStatusで表示を切り替える
        modeStatus () {
            if (this.modeStatus === 'addMode') {
                this.page_title = 'ゴルフグループ登録';
            } else if (this.modeStatus === 'changeMode') {
                this.page_title = 'ゴルフグループ変更';
            }
        },
        // 親コンポーネント(GolfGroup.vue)から渡された値をinputに代入
        editInfo () {
            this.from_set_data.golf_group_code = this.editInfo.golf_group_code;
            this.from_set_data.golf_group_name = this.editInfo.golf_group_name;
            this.from_set_data.point_use_type = String(this.editInfo.point_use_type);
            this.from_set_data.point_remainder_type = String(this.editInfo.point_remainder_type);
        }
    },
    methods: {
        /** ----------------------------------------------
        * 初期表示時処理
        * ---------------------------------------------- */
        Initialize () {
            this.valid = true;
            this.lazy = false;
            this.addOverlay = false;
            this.changeOverlay = false;
            this.from_set_data.golf_group_code = '';
            this.from_set_data.golf_group_name = '';
            this.from_set_data.point_use_type = '';
            this.from_set_data.point_remainder_type = '';
            this.process.result = '';
            this.process.resultText = '';
            this.modeStatus = '';
        },
        /** ----------------------------------------------
        * 登録処理
        * ---------------------------------------------- */
        registerGolfGroup () {
            // 二重送信防止処理
            if (this.process.processing) return;
            this.process.processing = true;

            this.$apollo.mutate({
                mutation: REGISTER_GOLFGROUP,
                variables: {
                    golf_group_code: this.from_set_data.golf_group_code,
                    golf_group_name: this.from_set_data.golf_group_name,
                    point_use_type: this.from_set_data.point_use_type,
                    point_remainder_type: this.from_set_data.point_remainder_type
                }
            }).then(res => {
                this.process.result = res.data.RegisterGolfGroup.result;
                if (this.process.result === 1) {
                    this.closeModal();
                } else if (this.process.result === 0) {
                    this.process.resultText = this.$t('result.error.add');
                }
                this.process.processing = false;
            }).catch(error => {
                this.error = error;
                this.process.processing = false;
            });
        },
        /** ----------------------------------------------
        * 更新処理
        * ---------------------------------------------- */
        updateGolfGroup () {
            // 二重送信防止処理
            if (this.process.processing) return;
            this.process.processing = true;

            this.$apollo.mutate({
                mutation: UPDATE_GOLFGROUP,
                variables: {
                    golf_group_code: this.from_set_data.golf_group_code,
                    golf_group_name: this.from_set_data.golf_group_name,
                    point_use_type: this.from_set_data.point_use_type,
                    point_remainder_type: this.from_set_data.point_remainder_type
                }
            }).then(res => {
                this.process.result = res.data.UpdateGolfGroup.result;
                if (this.process.result === 1) {
                    this.closeModal();
                } else if (this.process.result === 0) {
                    this.process.resultText = this.$t('result.error.change');
                }
                this.process.processing = false;
                this.Initialize();
            }).catch(error => {
                this.process.result = 0;
                this.process.resultText = this.$t('result.error.change');
                this.process.processing = false;
                this.process.result = '';
                this.error = error;
            });
        },
        addModal () {
            this.Initialize();
            this.modeStatus = 'addMode';
            this.dialog = true;
        },
        changeModal () {
            this.Initialize();
            this.modeStatus = 'changeMode';
            this.dialog = true;
        },
        closeModal () {
            this.Initialize();
            this.$emit('refresh-event');
            this.dialog = false;
        },
        validateCheck () {
            if (this.$refs.form.validate()) {
                if (this.modeStatus === 'addMode') {
                    this.addOverlay = true;
                } else if (this.modeStatus === 'changeMode') {
                    this.changeOverlay = true;
                }
            }
        }
    }
};
</script>

<style>
.formWidth{
    max-width: 80%;
}
</style>
